"use client";
import React from "react";
import HeroPage from "./components/HeroPage";
import { View } from "./ListingPage1";
import HeroSearch from "./components/HeroSearch";
import Breadcrumbs from "./components/BreadCrumb";

import { findPropertiesByType } from "../../constants/mockProperties";
import { PropertyType } from "src/types";
import { UnitsResponse } from "src/app/lib/useFetchUnits";

const Rent1 = ({ listings }: { listings: PropertyType[] }) => {
  return (
    <section className="max-w-full overflow-clip">
      <HeroPage
        subHeader="Your next move starts here-browse, find, and secure your perfect property today!"
        header="Property For Rent"
      />
      <HeroSearch />
      <div className="py-4 wrapper">
        <Breadcrumbs />
      </div>
      {/* Render all the units */}
      <View
        placeholder={listings as unknown as UnitsResponse}
        text="We’re currently updating our rental listings to bring you the best options in the market - from pocket friendly apartments, spacious family homes and commercial spaces. New listings will be available soon!"
        type="rent"
        properties={[
          ...findPropertiesByType("rent"),
          ...findPropertiesByType("rent"),
          ...findPropertiesByType("rent"),
        ]}
      />
      {/* Show the "Load More" button if there are more units to load */}
    </section>
  );
};

export default Rent1;
